export function me(state = {}, action) {
  switch (action.type) {
    case 'ME_DONE':
      return { ...action, type: undefined };
    default:
      return state;
  }
}
